import { useQuery } from '@tanstack/react-query'
import { useSupabase } from '@/lib/supabase-context'
import { useOrganizacion } from '@/core/providers/OrganizacionProvider'
import { usePermissions } from '@/hooks/usePermissions'
import { cuentaCorrienteService } from '@/services/cuentaCorrienteService'

export const cuentaCorrienteKeys = {
  all: ['cuenta-corriente'] as const,
  cliente: (clienteId: string) => [...cuentaCorrienteKeys.all, clienteId] as const,
}

/**
 * Resumen de cuenta corriente de un cliente para la ficha 360 (ORR-141):
 * antigüedad de deuda, último pago / días sin pago y última notificación.
 * Sin `verMovimientos` la consulta no corre.
 */
export function useCuentaCorrienteCliente(clienteId: string) {
  const { supabase, isLoading: supabaseLoading } = useSupabase()
  const { organizacionId } = useOrganizacion()
  const { puede } = usePermissions()

  return useQuery({
    queryKey: cuentaCorrienteKeys.cliente(clienteId),
    queryFn: () => cuentaCorrienteService.obtenerResumen(supabase!, organizacionId!, clienteId),
    staleTime: 60000,
    enabled: !!supabase && !supabaseLoading && !!clienteId && !!organizacionId && puede.verMovimientos === true,
  })
}
